import { Table as AntTable } from 'antd';
import styled from 'styled-components';

export const Table = styled(AntTable)`
  .ant-table {
    max-height: 650px;
    overflow-y: auto;
  }
`;
